import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form, Card } from 'ui/components';
import { Select } from 'ui/components';
import { Onboarding, Auth } from 'services/action';
import { useHistory } from 'react-router-dom';
import { formatDate } from 'utilities/common';

const initialState = {
  user: {
    username: '',
    password: '',
    confirm_password: '',
  },
  client: {
    type: '',
    company_name: '',
    name: '',
    phone: '',
    email: '',
    address: '',
    region: '',
  },
};

const options = [
  { value: 'shipper', label: 'Shipper' },
  { value: 'carrier', label: 'Carrier' },
];

const RegistrationScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const [{ client, user }, setState] = React.useState(initialState);

  const $handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      type: 'company',
      company_type: client?.type?.value,
      company_name: client?.company_name,
      name: client?.name,
      phone: client?.phone,
      email: client?.email,
      address: client?.address,
      village_id: client?.region?.village_id,
      username: user?.username,
      password: user?.password,
      confirm_password: user?.confirm_password,
      is_active: true,
      register_app: 'operator'
    };

    const submit = await Dispatch(Onboarding.$create(payload));

    if (submit?.message === 'success' && submit?.data) {
      const login = {
        username: user?.username,
        password: user?.password,
        app: 'tms'
      };
      await Dispatch(Auth.$signin(login));
    }
  };

  return (
    <div className="markdown row p-0 flex-wrap">
      <div className="col-md-3 signin d-none d-lg-block"></div>
      <div
        className="col-md-9 col-12 d-flex flex-column justify-content-center align-items-center flex-wrap ms-md-n1"
        style={{ minHeight: '100vh' }}
      >
        <div className="mb-3 text-center mt-md-0 mt-3">
          <div className="page-pretitle">Welcome to envio logistics</div>
          <h2 className="page-title">Lengkapi data dibawah ini</h2>
        </div>

        <form onSubmit={$handleSubmit} className="px-3 px-md-0 w-100">
          <div className="row flex-wrap">
            <div className="col-md-6 mb-3 mb-md-0">
              <Card className="p-2">
                <div className="hr-text hr-text-left text-primary mb-4 mt-3">
                  Data Pengguna
                </div>

                <div className="form-group mb-3 ">
                  <Form.InputAddon
                    required
                    value={user?.username}
                    onChange={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        user: {
                          ...prevState.user,
                          username: e.target.value,
                        },
                      }))
                    }
                    type="text"
                    label="Username"
                    error={StateForm?.errors?.username}
                    md
                  />
                </div>
                <div className="form-group mb-3 ">
                  <Form.InputAddon
                    required
                    value={user?.password}
                    onChange={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        user: {
                          ...prevState.user,
                          password: e.target.value,
                        },
                      }))
                    }
                    label="Password"
                    type="password"
                    error={StateForm?.errors?.password}
                    md
                  />
                </div>
                <div className="form-group mb-3 ">
                  <Form.InputAddon
                    required
                    value={user?.confirm_password}
                    onChange={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        user: {
                          ...prevState.user,
                          confirm_password: e.target.value,
                        },
                      }))
                    }
                    label="Konfirmasi Password"
                    type="password"
                    error={StateForm?.errors?.confirm_password}
                    md
                  />
                </div>
              </Card>
            </div>

            <div className="col-md-6">
              <Card className="p-2 login">
                <div className="">
                  <div className="hr-text hr-text-left text-primary mb-4 mt--3 mt-3">
                    Data Perusahaan
                  </div>
                  <div className="form-group mb-3 ">
                    <label className="form-label required">Tipe Perushaan</label>
                    <Select
                      isClearable
                      classNamePrefix={
                        StateForm?.errors?.company_type ? 'is-invalid' : 'select'
                      }
                      placeholder=""
                      value={client?.type}
                      options={options}
                      onChange={(e) =>
                        setState((prevState) => ({
                          ...prevState,
                          client: {
                            ...prevState.client,
                            type: e,
                          },
                        }))
                      }
                    />

                    {StateForm?.errors?.company_type && (
                      <div
                        className="invalid-feedback"
                        style={{ display: 'block' }}
                      >
                        {StateForm?.errors?.company_type}
                      </div>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <Form.InputAddon
                      required
                      value={client?.name}
                      onChange={(e) =>
                        setState((prevState) => ({
                          ...prevState,
                          client: {
                            ...prevState.client,
                            name: e.target.value,
                          },
                        }))
                      }
                      type="text"
                      label="Nama Perusahaan"
                      error={StateForm?.errors?.name}
                      md
                    />
                  </div>
                  <div className="form-group mb-3">
                    <Form.InputAddon
                      required
                      value={client?.company_name}
                      onChange={(e) =>
                        setState((prevState) => ({
                          ...prevState,
                          client: {
                            ...prevState.client,
                            company_name: e.target.value,
                          },
                        }))
                      }
                      type="text"
                      label="Nama Penanggung Jawab"
                      error={StateForm?.errors?.company_name}
                      md
                    />
                  </div>
                  <div className="form-group mb-3 ">
                    <Form.InputAddon
                      required
                      value={client?.phone}
                      onChange={(e) =>
                        setState((prevState) => ({
                          ...prevState,
                          client: {
                            ...prevState.client,
                            phone: e.target.value,
                          },
                        }))
                      }
                      type="number"
                      label="No. Handphone Penanggung Jawab"
                      error={StateForm?.errors?.phone}
                      md
                    />
                  </div>
                  <div className="form-group mb-3 ">
                    <Form.InputAddon
                      required
                      value={client?.email}
                      onChange={(e) =>
                        setState((prevState) => ({
                          ...prevState,
                          client: {
                            ...prevState.client,
                            email: e.target.value,
                          },
                        }))
                      }
                      type="email"
                      label="Email Penanggung Jawab"
                      error={StateForm?.errors?.email}
                      md
                    />
                  </div>
                  <div className="form-group mb-3 ">
                    <Select.Remote
                      required
                      label="Kab./Kota/Kec."
                      placeholder=""
                      url="/region"
                      value={client?.region?.village_id}
                      row={(d) => {
                        return {
                          value: d.village_id,
                          label: `${d.village_name}, ${d.district_name}, ${d.regency_name}, ${d?.province_name} ${d.postal_code} `,
                        };
                      }}
                      onSelected={(c) => {
                        setState((prevState) => ({
                          ...prevState,
                          client: {
                            ...prevState.client,
                            region: c,
                          },
                        }));
                      }}
                      errors={StateForm?.errors?.village_id}
                      hint="cari berdasarkan kode pos / kabupaten / kota / kecamatan"
                    />
                  </div>
                  <div className="form-group mb-3 ">
                    <Form.Textbox
                      required
                      value={client?.address}
                      onChange={(e) =>
                        setState((prevState) => ({
                          ...prevState,
                          client: {
                            ...prevState.client,
                            address: e.target.value,
                          },
                        }))
                      }
                      label="Alamat Perusahaan"
                      type="text"
                      error={StateForm?.errors?.address}
                    />
                  </div>
                </div>
              </Card>
            </div>
          </div>

          <div className="form-footer d-flex flex-wrap justify-content-md-end align-items-center align-content-center justify-content-center gap-3 me-3">
            <button
              type="button"
              disabled={StateForm?.loading}
              className="btn btn-light  py-2"
              onClick={() => History.push(`/signin`)}
            >
              {!StateForm?.loading ? (
                'Sudah punya akun ? Login sekarang'
              ) : (
                <div className="spinner-border" role="status"></div>
              )}
            </button>
            <button
              type="submit"
              disabled={StateForm?.loading}
              className="btn btn-primary py-2"
            >
              {!StateForm?.loading ? (
                'Daftar Sekarang'
              ) : (
                <div className="spinner-border" role="status"></div>
              )}
            </button>
          </div>
        </form>

        <small className="text-muted mt-3">
          &copy; {formatDate(new Date(), 'YYYY')} envio.co.id
        </small>
      </div>
    </div>
  );
};

export default RegistrationScreen;
